import { useEffect, useState, type ReactElement } from 'react';
import { HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { insertExceptionEvent, removeExceptionEvent } from 'src/features/dashboard/hooks/exceptionEvents';
import { ExceptionEventType } from 'src/features/dashboard/types/ExceptionEventType';
import { AppDispatch, RootState } from "src/app/store";
import { useDispatch, useSelector } from "react-redux";

export interface DashboardEventProps {

}

export function DashboardEvent(props: DashboardEventProps): ReactElement {

        const [connection, setConnection] = useState<HubConnection | null>(null);
        const dispatch = useDispatch<AppDispatch>();
        const { exceptionEvents } = useSelector((state: RootState) => state.exceptionEvents);

        useEffect(() => {
                // 1. Build the connection
                var token = localStorage.getItem('authToken') || "";
                const newConnection = new HubConnectionBuilder()
                        .withUrl("/dashboardEvents", {
                                accessTokenFactory: () => token
                        })
                        .withAutomaticReconnect()
                        .configureLogging(LogLevel.Error)
                        .build();

                setConnection(newConnection);
        }, []);

        useEffect(() => {
                if (connection) {

                        connection.on('dsxEvent', (message) => {
                                if (exceptionEvents.length > 25) {
                                        dispatch(removeExceptionEvent(message));
                                }
                                else if (exceptionEvents.length < 25) {
                                        dispatch(insertExceptionEvent(JSON.parse(message)));
                                }

                        });

                        // 2. Start the connection and set up listeners
                        connection.start().catch(e => console.log('Connection failed: ', e));

                        // 3. Clean up on unmount
                        // return () => {
                        //         connection.stop();
                        // };
                }
        }, [connection]);

        return <>
        </>
};
